import Icon from "@mui/icons-material/VisibilityRounded";

export default function InspectorIcon(props) {
	return <Icon fontSize="small" color={props.color} />;
}
